import React from 'react';
export function CompactSpaceSavingSection() {
  return <div className="w-full max-w-[1400px] mt-16 px-4" data-id="element-125">
      <div className="bg-blue-900 rounded-3xl overflow-hidden shadow-2xl" data-id="element-126">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center" data-id="element-127">
          {/* Text Content */}
          <div className="p-8 md:p-12 text-white" data-id="element-128">
            <h3 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-129">
              Compact & Space-Saving
            </h3>
            <p className="text-lg md:text-xl leading-relaxed" data-id="element-130">
              Designed for modern kitchens, it takes up little space yet
              delivers powerful performance. Whether you keep it on the counter
              for daily use or tuck it into a cabinet, it's always ready without
              crowding your kitchen.
            </p>
          </div>

          {/* Image */}
          <div className="relative" data-id="element-131">
            <img src="https://cdn.magicpatterns.com/uploads/1sye4cjHMYq4tvV8Aq69dj/image.png" alt="Compact peeling machine being stored in cabinet" className="w-full h-auto rounded-2xl" data-id="element-132" />
          </div>
        </div>
      </div>
    </div>;
}